import { zodResolver } from "@hookform/resolvers/zod";
import { CreateOrderRequest } from "services/orders/models/OrdersTypes";
import { z } from "zod";
import {ProgramByIDResponse} from "../../../../services/programs/models/ProgramTypes";

export const getCreateOrderSchema = (t: any,program?:ProgramByIDResponse |null ) => {
  const schema = z.object({
    programId: z
      .number({
        required_error: t("Common:invalidValue"),
        invalid_type_error: t("Common:invalidValue"),
      })
      .min(1, t("Common:invalidValue")),
    centreManagementId:program == null? z.number().optional() : program.isCentreManagementRequired?z.number({
      required_error: t("Common:requiredField"),
      invalid_type_error: t("Common:requiredField")
    }).min(1, t("Common:requiredField")):z.number().optional(),
    formSubject:program == null? z.string().optional() : program.isFromSubjectRequired?z.string({
      required_error: t("Common:requiredField"),
      invalid_type_error: t("Common:requiredField")
    }).min(1, t("Common:requiredField")):z.string().optional(),
    formValue: z.string().optional(),
    isAcceptedConditionAndRules: z.boolean().refine((value) => value === true, {
      message: t("Common:requiredField"),
    }),
    isAcceptedCommitments: z.boolean().refine((value) => value === true, {
      message: t("Common:requiredField"),
    }),
    filesIds:program == null? z
      .array(
        z.string({
          message: t("Common:pleaseUploadAtLeastOneFile"),
        }),
      ) .optional() :program.isFileAttachmentRequired? z. array(
        z.string({
          message: t("Common:pleaseUploadAtLeastOneFile"),
        }),
    ).min(1, t("Common:pleaseUploadAtLeastOneFile")):z.array(z.string({
      message: t("Common:pleaseUploadAtLeastOneFile"),
    }).optional()),
    researchFieldId:program == null?  z.number().optional(): program.isResearchFieldRequired?z.number({
      required_error: t("Common:requiredField"),
      invalid_type_error: t("Common:requiredField")
    }).min(1, t("Common:requiredField")):z.number().optional(),
    researchPriorityId: z.number({
      required_error: t("Common:requiredField"),
      invalid_type_error: t("Common:requiredField")
    }).min(1, t("Common:requiredField")),
    collegeId: z.number({
      required_error: t("Common:requiredField"),
      invalid_type_error: t("Common:requiredField")
    }).min(1, t("Common:requiredField")),
    researchPaperId: z.number({
      required_error: t("Common:requiredField"),
      invalid_type_error: t("Common:requiredField")
    }).min(1, t("Common:requiredField")),
    programOrderDetails: z.array(z.object({
      locale: z.string(),
      summaryOfResearch: z.string({
        required_error: t("Common:requiredField"),
        invalid_type_error: t("Common:requiredField")
      }).min(1, t("Common:requiredField")),
    })).min(2, t("Common:requiredField")).refine(
      (details) => {
        const arDetail = details.find(d => d.locale.toLowerCase() === 'ar');
        const enDetail = details.find(d => d.locale.toLowerCase() === 'en');
        return arDetail?.summaryOfResearch && arDetail.summaryOfResearch.length > 0 &&
               enDetail?.summaryOfResearch && enDetail.summaryOfResearch.length > 0;
      },
      { message: t("Common:requiredField") }
    ),
    subspecialty: z.string().optional(),
    searchURL: z.string({
      required_error: t("Common:requiredField"),
      invalid_type_error: t("Common:requiredField")
    }).min(1, t("Common:requiredField")),
    isFormValueReady: z
      .boolean({ message: t("pleaseFillAllRequiredFields") })
      .refine((value) => value === true, { message: t("pleaseFillAllRequiredFields") }),
    isDraft: z.boolean(),
  }) as z.ZodType<CreateOrderRequest>;

  return zodResolver(schema);
};
